<template>
  <div class="rc-wrapper rc-plain-layout">
    <rc-skip-nav/>
    <rc-site-header
      :class="{
        disabled:
          this.$route.meta.layoutOptions &&
          this.$route.meta.layoutOptions.disableHeader
      }"
    />
    <div class="main-container">
      <div class="row">
        <div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
          <rc-site-content />
        </div>
      </div>
    </div>
    <rc-site-footer
      v-if="
        !this.$route.meta.layoutOptions ||
          !this.$route.meta.layoutOptions.hideFooter
      "
    />
    <rc-notifications />
  </div>
</template>

<script>
import SkipNav from "@/libvue/components/skipnav/SkipNav.vue";
import SiteContent from "#/layout/components/SiteContent.vue";
import SiteFooter from "#/layout/components/SiteFooter.vue";
import SiteHeader from "#/layout/components/SiteHeader.vue";

export default {
  name: "UtilLayout",
  components: {
    "rc-skip-nav": SkipNav,
    "rc-site-content": SiteContent,
    "rc-site-footer": SiteFooter,
    "rc-site-header": SiteHeader
  }
};
</script>
